import { Box, CircularProgress } from "@mui/material"
import type { ReactNode } from "react"

import theme from "@/styles/mui-theme"

interface CircularLoadingIndicatorProps {
  size?: number
}

const CircularLoadingIndicator = ({ size = 48 }: CircularLoadingIndicatorProps): ReactNode => (
  <Box className='flex items-center justify-center'>
    <CircularProgress
      size={size}
      className='transition-opacity duration-300 ease-in-out'
      sx={{
        color: theme.palette.primary.main,
      }}
    />
  </Box>
)

export default CircularLoadingIndicator
